import React from 'react';
import { Typography, Alert } from '@one-thd/sui-atomic-components';

export interface NoSearchResultsEmptyStateProps {
  searchTerm: string;
  supportedSearchFields: string[];
}

export const NoSearchResultsEmptyState: React.FC<NoSearchResultsEmptyStateProps> = ({
  searchTerm,
  supportedSearchFields
}) => (
  <div className="sui-flex sui-flex-col sui-items-center sui-gap-3 sui-text-center">
    <div>
      <Typography variant="body-base" color="subtle">
        Hmm...we couldn&apos;t find
      </Typography>
      <Typography variant="h1">&quot;{searchTerm}&quot;</Typography>
    </div>
    <div className="sui-flex sui-flex-col sui-items-center sui-gap-3">
      <Typography variant="body-base">Try adjusting your search. You can search by:</Typography>
      <ul className="sui-list-disc sui-ml-6 sui-text-left">
        {supportedSearchFields.map((field) => (
          <li key={field}>
            <Typography variant="body-base">{field}</Typography>
          </li>
        ))}
      </ul>
      <Alert status="info" size="small" headline="Older search methods retired">
        Some older search methods may no longer return results.
      </Alert>
    </div>
  </div>
);
